import { Subject } from 'rxjs';

import { CoordinatorService } from './coordinator.service';

export class MyWorker {
    private _w: Worker;

    private _initMode = false; //true;

    private _pendingPromises = new Map<
        string,
        { resolve: (value: any) => void; reject: (reason?: any) => void }
    >();

    response$ = new Subject<any>();

    reportSuccess$ = new Subject<any>();
    reportError$ = new Subject<any>();

    constructor(
        private coords: CoordinatorService,
        public tag: string,
        private _source: string,
    ) {
        this._w = new Worker(this._source);

        // this._ping()

        this._w.addEventListener('message', (event) => {
            const action = event.data.action;
            switch (action) {
                case 'success':
                    const p = event.data.payload;
                    return this.reportSuccess$.next(p?.payload || p);
                case 'error':
                    return this.reportError$.next(event.data.payload);
                default:
                    this.response$.next(event.data);
            }
        });

        const mW = this;

        this._w.onmessage = function (event) {
            const respId = event.data.mId || event.data.payload?.mId;
            const h = mW._pendingPromises.get(respId);
            if (h) {
                h.resolve(event.data);
                mW._pendingPromises.delete(respId);
            }
        };

        // Handle any errors that occur
        this._w.onerror = function (error) {
            // const h = mW._pendingPromises.get(mId);
            // h?.reject(error);
            console.log('Worker error', error);
            // mW._pendingPromises.delete(mId);
        };
    }

    async directPost(payload: any) {
        this._w.postMessage(payload);
    }

    async call(action: string, payload: any) {
        const mId = this.coords.uniqueId();
        // console.log("CALL", action, payload, mId);

        return new Promise((resolve, reject) => {
            this._pendingPromises.set(mId, { resolve, reject });
            this._w.postMessage({ mId, action, payload });
        });
    }

    get isReady() {
        return !this._initMode;
    }
}
